import { getApiUrl } from '../utils/apiUtils';
import { getPatients } from './patientsApi';
import { getProtocols } from './protocolsApi';
import { getOrders } from './ordersApi';

// Search patients by name or MRN
export const searchPatients = async query => {
  try {
    // For now, use existing getPatients and filter client-side
    // In production, this would be a dedicated search endpoint
    const response = await getPatients();
    const lowercaseQuery = query.toLowerCase();
    
    // Ensure we have an array to work with
    let allPatients = [];
    if (Array.isArray(response)) {
      allPatients = response;
    } else if (response && Array.isArray(response.patients)) {
      allPatients = response.patients;
    } else if (response && Array.isArray(response.data)) {
      allPatients = response.data;
    } else {
      console.warn('Unexpected patients response structure:', response);
      return [];
    }

    return allPatients.filter(
      patient => {
        // Handle different patient name formats
        const fullName = patient.name || 
                        `${patient.firstName || ''} ${patient.lastName || ''}`.trim() ||
                        '';
        const mrn = patient.mrn || patient.MRN || '';
        const id = patient.id?.toString() || '';
        
        return fullName.toLowerCase().includes(lowercaseQuery) ||
               mrn.toLowerCase().includes(lowercaseQuery) ||
               id.toLowerCase().includes(lowercaseQuery) ||
               patient.firstName?.toLowerCase().includes(lowercaseQuery) ||
               patient.lastName?.toLowerCase().includes(lowercaseQuery);
      }
    );
  } catch (error) {
    console.error('Error searching patients:', error);
    return [];
  }
};

// Search protocols by name or surgery type
export const searchProtocols = async query => {
  try {
    const response = await getProtocols();
    const lowercaseQuery = query.toLowerCase();
    
    // Extract protocols array from response
    let allProtocols = [];
    if (Array.isArray(response)) {
      allProtocols = response;
    } else if (response && Array.isArray(response.protocols)) {
      allProtocols = response.protocols;
    } else if (response && Array.isArray(response.data)) {
      allProtocols = response.data;
    } else {
      console.warn('Unexpected protocols response structure:', response);
      return [];
    }

    return allProtocols.filter(
      protocol =>
        protocol.name?.toLowerCase().includes(lowercaseQuery) ||
        protocol.surgeryType?.toLowerCase().includes(lowercaseQuery) ||
        protocol.description?.toLowerCase().includes(lowercaseQuery)
    );
  } catch (error) {
    console.error('Error searching protocols:', error);
    return [];
  }
};

// Search orders by name or category
export const searchOrders = async query => {
  try {
    // Import apiUtils for making the API call
    const { apiUtils } = await import('../utils/apiUtils');
    
    // Call the search endpoint
    const response = await apiUtils.get(`/api/orders/search?q=${encodeURIComponent(query)}`);
    
    // Extract orders array from response
    let allOrders = [];
    if (Array.isArray(response)) {
      allOrders = response;
    } else if (response && Array.isArray(response.orders)) {
      allOrders = response.orders;
    } else if (response && Array.isArray(response.data)) {
      allOrders = response.data;
    } else {
      console.warn('Unexpected orders response structure:', response);
      return [];
    }
    
    return allOrders;
  } catch (error) {
    console.error('Error searching orders:', error);
    return [];
  }
};
